/* TC32 · Guardia del kit
   Mantiene las líneas "Kit TC32" (que activan los descuentos) exactamente iguales
   a las piezas del kit que siguen en el carrito. Si el cliente quita una pieza,
   ajusta las líneas; si alguien agrega líneas de kit a mano, las quita. */
(function () {
  if (window.__tc32KitGuard) return;
  window.__tc32KitGuard = true;

  var TOKEN_HANDLE = 'kit-tc32';
  var PROT_TYPES = ['guantes', 'caretas', 'conchas'];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, timer = null;
  var nativeFetch = window.fetch.bind(window);

  function isToken(i) { return i.handle === TOKEN_HANDLE; }
  function sku(i) { return (i.sku || '').toUpperCase(); }

  function wanted(items) {
    var kits = {};
    items.forEach(function (i) {
      if (isToken(i)) return;
      var k = i.properties && i.properties._kit;
      if (!k) return;
      var kit = kits[k] || (kits[k] = { prot: 0, acc: 0, types: {} });
      var t = (i.product_type || '').toLowerCase();
      if (PROT_TYPES.indexOf(t) > -1) { kit.prot += i.quantity; kit.types[t] = 1; }
      else kit.acc += i.quantity;
    });
    var out = {};
    Object.keys(kits).forEach(function (k) {
      var kit = kits[k], pieces = kit.prot + kit.acc;
      var trio = kit.types.guantes && kit.types.caretas && kit.types.conchas;
      var ok = pieces >= 2;
      out[k] = {
        'KIT-PROT-5': ok && !trio ? kit.prot : 0,
        'KIT-PT-10': ok && trio ? kit.prot : 0,
        'KIT-ACC-10': ok ? kit.acc : 0
      };
    });
    return out;
  }

  function check() {
    if (busy) return;
    busy = true;
    nativeFetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = wanted(cart.items), updates = {}, changed = false;
        var left = {};
        cart.items.forEach(function (i) {
          if (!isToken(i)) return;
          var k = i.properties && i.properties._kit, id = k + '|' + sku(i);
          if (!(id in left)) left[id] = k && want[k] ? (want[k][sku(i)] || 0) : 0;
          var q = Math.min(i.quantity, left[id]);
          left[id] -= q;
          if (q !== i.quantity) { updates[i.key] = q; changed = true; }
        });
        if (!changed) return false;
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return true; });
      })
      .then(function (changed) {
        busy = false;
        if (!changed) return;
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        document.dispatchEvent(new Event('cart:refresh'));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          nativeFetch(root + 'cart?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (s) { try { drawer.renderContents({ sections: s }); } catch (e) {} })
            .catch(function () {});
        }
      })
      .catch(function () { busy = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(check, 400); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(change|update|add|clear)(\.js)?/.test(url)) p.then(schedule, schedule);
    return p;
  };
  document.addEventListener('submit', function (e) {
    var a = (e.target && e.target.action) || '';
    if (/\/cart/.test(a)) schedule();
  }, true);

  var css = document.createElement('style');
  css.textContent = '[data-tc32-token] quantity-input,[data-tc32-token] .quantity,[data-tc32-token] cart-remove-button{display:none!important}';
  document.head.appendChild(css);
  function markTokens() {
    document.querySelectorAll('a[href*="/products/' + TOKEN_HANDLE + '"]').forEach(function (a) {
      var row = a.closest('tr, li, .cart-item, .cart-drawer__item');
      if (row) row.setAttribute('data-tc32-token', '');
      a.removeAttribute('href');
    });
  }
  new MutationObserver(markTokens).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { markTokens(); check(); });
  else { markTokens(); check(); }
})();
